export default __webpack_public_path__ + "static/5-6375df62edf866bdeceeae1c126f5d43.jpg";